export default {
  channel: 'Canal',
  spend: 'Inversión',
  share: 'Participación',
  copy: 'Copiar al portapapeles',
  copied: '¡Copiado!',
  copyFailed: 'No se pudo copiar',
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen'
}
